module.exports = __webpack_public_path__ + "static/media/alarm.4d47dbab.png";